__turbopack_context__.v({
  "container": "Gxvv-G_container",
  "inputContainer": "Gxvv-G_inputContainer",
  "inputWrapper": "Gxvv-G_inputWrapper",
});
